import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { licenses } from '../../docs-routes'

const LicensesInfo = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      The Licenses management is where you manage your Eggplant DAI licenses:
    </Color>
    <br />
    <br />
    <b>Developer license</b>
    <br />
    <Color variant='theme-description-text'>
      The number of concurrent users that can access and use Eggplant DAI to build tests and models and manually run tests.
    </Color>
    <br />
    <br />
    <b>Execution license</b>
    <br />
    <Color variant='theme-description-text'>
      The number of concurrent headless tests that can run simultaneously.
    </Color>
    <br />
    <br />
    <Color variant='theme-description-text'>
      To add a new license, click Add license. The Add license page opens. Enter your DAI license key, review the Software License Management Agreement, and click Agree.
    </Color>
    <br />
    <br />
    <Color variant='theme-description-text'>
      If the license is invalid, please contact our customer support.
    </Color>
    <DocusaurusFooter path={licenses} />
  </Paragraph>

export default LicensesInfo
